import * as r from 'runtypes';

export const SuperUserFlagsRuntype = r.Partial({
    has_users_access: r.Boolean,
    can_login_as_user: r.Boolean,
    can_manage_admins: r.Boolean,
    has_admins_access: r.Boolean,
    has_sales_access: r.Boolean,
    has_faq_access: r.Boolean,
    has_tours_access: r.Boolean,
    has_bicycle_access: r.Boolean,
    has_fleet_access: r.Boolean,
    has_contacts_access: r.Boolean,
    has_partners_access: r.Boolean,
    has_instagram_access: r.Boolean,
    has_google_reviews_access: r.Boolean,
    has_page_meta_access: r.Boolean,
});
export type SuperUserFlags = r.Static<typeof SuperUserFlagsRuntype>;
